import CompaniesContainer from './containers/CompaniesContainer';
export default CompaniesContainer;
